import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SystemAnnouncementBar from '@/components/announcements/SystemAnnouncementBar';
const ANNOUNCEMENT_HEIGHT = 60;

const AppLayout = () => {
const location = useLocation();


const hiddenRoutes = ['/system-status','/onboarding'];
const hideAnnouncement = hiddenRoutes.includes(location.pathname);

return (
<div 
// style={{
// paddingTop: hideAnnouncement ? 0 : ANNOUNCEMENT_HEIGHT
// }}
className="min-h-screen flex flex-col">
{!hideAnnouncement && <SystemAnnouncementBar />}

{/* Page content */}
<div className="flex-1 relative">
<Outlet />
</div>
</div>
);
};

export default AppLayout;
